import {
  Component,
  ViewEncapsulation,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
  ChangeDetectorRef,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { Page } from 'src/app/ui/datatable/page';
import { PaginationObject } from 'src/app/models/paginationObject';
import { SortObject } from 'src/app/models/sortObject';
import { HttpClient } from '@angular/common/http';
import { remove } from 'lodash';
import { ExportToCsv } from 'export-to-csv';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { StringToDate } from 'src/app/utils/stringToDate';
import { OrdersService } from 'src/app/user/dashboard/orders/service/orders.service';
import { NavigationService } from 'src/app/app-layout/navigation/service/navigation.service';
import sortHelper from 'src/app/helpers/sort';
import { BudgetsService } from 'src/app/user/dashboard/budgets/service/budgets.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-datatable',
    templateUrl: './datatable.component.html',
    styleUrls: ['./datatable.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [OrdersService, BudgetsService],
    standalone: false
})
export class DatatableGenericComponent implements OnInit, AfterViewInit {
  @ViewChild('table', { static: false }) table: DatatableComponent;
  @ViewChild('plainCell', { static: true }) plainCell: TemplateRef<any>;
  @ViewChild('dayHourFormat', { static: true }) dayHourFormat: TemplateRef<any>;
  @ViewChild('personNameCell', { static: true }) personNameCell: TemplateRef<any>;
  @ViewChild('checkboxCell', { static: true }) checkboxCell: TemplateRef<any>;
  @ViewChild('dateCell', { static: true }) dateCell: TemplateRef<any>;
  @ViewChild('translateCell', { static: true }) translateCell: TemplateRef<any>;
  @ViewChild('percentageCell', { static: true }) percentageCell: TemplateRef<any>;
  @ViewChild('currencyCell', { static: true }) currencyCell: TemplateRef<any>;
  @ViewChild('timeCell', { static: true }) timeCell: TemplateRef<any>;
  @ViewChild('navigationIcon', { static: true }) navigationIcon: TemplateRef<any>;
  @ViewChild('navigationAndJiraIcon', { static: true }) navigationAndJiraIcon: TemplateRef<any>;
  @ViewChild('jiraIcon', { static: true }) jiraIcon: TemplateRef<any>;
  @ViewChild('errorDetails', { static: true }) errorDetails: TemplateRef<any>;

  @Input() public service: Function;
  @Input() public deleteService: Function;
  @Input() public defaultColumns: [];
  @Input() public section: string;
  @Input() public subsection: string;
  @Input() public subsectionRoute: string = null;
  @Input() public enableFilter: boolean = true;
  @Input() public columnsToExclude: string[] = [];
  @Input() public isMultiForm: boolean = false;

  page = new Page();
  rows = new Array<any>();
  temp = [];
  columns = [];
  selectedTableColumns = [];
  columnsToDisplayInDropdown = [];
  data = {};

  rawEvent: any;
  contextmenuRow: any;
  contextmenuColumn: any;

  ColumnMode = ColumnMode;
  paginationObject = new PaginationObject();
  queryString = '';
  schema: any;
  selectedRows = [];
  checkAll: boolean = false;

  @Input() sortArray: SortObject[];

  csvOptions: any = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
  };
  csvExporter = new ExportToCsv(this.csvOptions);
  columnsExist = false;
  showSearch = false;
  searchColumnUpdate = new Subject<any>();
  tableData = null;
  booleanValues = [
    { value: null, name: 'All' },
    { value: 'true', name: 'True' },
    { value: 'false', name: 'False' },
  ];
  @HostListener('click', ['$event']) onClick(e) {
    if (this.showSearch && this.selectedTableColumns.find((el) => el.name == e.target.id)) {
      let columnValue = e.target.innerText;
      let columnName = e.target.id;
      if (this.schema?.[columnName] === 'percentage') {
        columnValue = columnValue.split(' ')[0];
      }
      if (this.schema?.[columnName] === 'date') {
        if (columnValue !== '') {
          columnValue = columnValue.split(' ')[0];
          columnValue = columnValue.replaceAll('/', '-');
          let temp = columnValue.split('-');
          columnValue = temp[2] + '-' + temp[1] + '-' + temp[0];
        }
      }
      if (this.schema?.[columnName] === 'currency') {
        columnValue = columnValue.split(' ')[0];
      }
      this.search(columnValue, columnName);
    }
  }

  constructor(
    public http: HttpClient,
    public translate: TranslateService,
    public route: ActivatedRoute,
    public cdr: ChangeDetectorRef,
    public ordersDashboardService: OrdersService,
    public budgetsDashboardService: BudgetsService,
    public toastService: ToastService,
    public navigationService: NavigationService,
    public router: Router
  ) {
    this.searchColumnUpdate.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value ? input.value.toString() : '', input.id);
    });
    if (window.location.pathname.includes('/dashboard/orders')) {
      this.ordersDashboardService.ordersDashboardData.subscribe(async (fetch) => {
        if (this.service) {
          await this.fetchData({
            paginationObject: this.paginationObject,
            sortArray: this.sortArray,
            query: this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '',
          });
          this.columns = [...this.columns];
          if (this.defaultColumns.length > 0) {
            this.selectTableColumns(this.defaultColumns);
          }
        }
      });
    }
    if (window.location.pathname.includes('/dashboard/budgets')) {
      this.budgetsDashboardService.budgetsDashboardData.subscribe(async (fetch) => {
        if (this.service) {
          await this.fetchData({
            paginationObject: this.paginationObject,
            sortArray: this.sortArray,
            query: this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '',
          });
          this.columns = [...this.columns];
          if (this.defaultColumns.length > 0) {
            this.selectTableColumns(this.defaultColumns);
          }
        }
      });
    }
  }

  convertStringToDate(strDate: string) {
    return StringToDate(strDate);
  }

  generateTable(data) {
    this.selectedRows = [];
    this.columns = [];
    this.tableData = data.data;
    this.schema = data.schema;
    if (this.tableData.content.length > 0) {
      Object.keys(this.tableData.content[0]).forEach((key, index) => {
        this.columns.push({
          name: key,
          prop: key,
          cellTemplate: this.pickCellTemplate(this.schema[key], key),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      });
      this.columns.push({
        name: 'Navigation',
        prop: 'Navigation',
        cellTemplate: this.checkNavigation(),
        sortable: false,
        selected: false,
        width: 120,
      });
    }

    this.rows = this.tableData.content;

    const source = this.tableData?.page ? this.tableData.page : this.tableData;
    this.page = {
      size: source?.size,
      totalElements: source?.totalElements,
      totalPages: source?.totalPages,
      pageNumber: source?.number,
    };

    const columnsToBeExcluded = [
      'Navigation',
      'identificationCodeMnemonic',
      'personaName',
      'personaIdentifier',
      ...this.columnsToExclude,
    ];

    let savedColumns = localStorage.getItem(this.section + '-default-columns')
      ? JSON.parse(localStorage.getItem(this.section + '-default-columns'))
      : [];
    if (savedColumns.length) {
      this.defaultColumns = savedColumns;
    }

    if (this.columnsToDisplayInDropdown?.length == 0 && this.columns.length > 0) {
      let defaultCheckedColumns = this.defaultColumns
        .map((elem: any) => {
          const baseColumn = this.columns.find((c: any) => c.name === elem.name);
          if (baseColumn) {
            baseColumn.selected = true;
            return baseColumn;
          } else return { name: null };
        })
        .filter((col: any) => !columnsToBeExcluded.find((c) => col.name === c));

      const extraColumns = this.columns.filter(
        (column) => !columnsToBeExcluded.concat(defaultCheckedColumns.map((c) => c.name)).find((c) => column.name === c)
      );
      this.columnsToDisplayInDropdown = defaultCheckedColumns.concat(extraColumns);
    }
  }

  ngOnInit() {
    this.loadData();
  }

  private async loadData() {
    let query = '';
    const search = globalThis.location.search;

    // Utilizzo di URLSearchParams per un parsing robusto e standard dell'URL
    const urlParams = new URLSearchParams(search);
    const queryParamValue = urlParams.get('query');
    const sortParamValue = urlParams.get('sort');

    if (queryParamValue) {
      this.queryString = queryParamValue;
      query = '&query=' + encodeURIComponent(this.queryString);
    }

    if (sortParamValue) {
      this.sortArray = [{ 
        prop: sortParamValue.split(',')[0], 
        dir: sortParamValue.split(',')[1] as any
      }];
    }

    const defaultSort = localStorage.getItem(this.section + '-default-sort');
    if (defaultSort) {
      this.sortArray = JSON.parse(defaultSort);
    }

    await this.fetchData({ 
      paginationObject: new PaginationObject(), 
      sortArray: this.sortArray, 
      query: query 
    });

    this.columns = [...this.columns];
    if (this.defaultColumns.length > 0) {
      this.selectTableColumns(this.defaultColumns);
    }

    // Popolamento dei campi di input interni alla tabella se la query è presente
    if (queryParamValue) {
      const fillValues = queryParamValue.split(/[=&]+/);
      let valueIndex = 0;

      fillValues.forEach(() => {
        if (valueIndex < fillValues.length) {
          const column = this.selectedTableColumns.find((el) => el.name === fillValues[valueIndex]);
          if (column) {
            column.searchValue = fillValues[valueIndex + 1];
          }
          valueIndex += 2;
        }
      });
    }
  }

  async fetchData(data) {
    let result = await this.service(data.paginationObject, data.sortArray, data.query);
    if (this.section === 'errors') {
      this.navigationService.errorCountSource.next(result.data.totalElements);
    }
    this.generateTable(result);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // moving footer inside the body so it has box shadow as per design
      let footer = document.getElementsByClassName('datatable-footer')[0];
      let body = document.getElementsByClassName('datatable-body')[0];
      body.appendChild(footer);
    }, 10);
  }

  setPage(pageInfo) {
    this.paginationObject = pageInfo;
    this.columnsExist = true;
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    this.fetchData({ paginationObject: pageInfo, sortArray: this.sortArray, query: query });
  }

  onSort(event) {
    this.sortArray = event.sorts;
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let sortQuery = sortHelper.constructSort(this.sortArray, true).split('sort=')[1];
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sort: sortQuery },
      queryParamsHandling: 'merge',
    });
    localStorage.setItem(this.section + '-default-sort', JSON.stringify(this.sortArray));
    this.fetchData({ paginationObject: new PaginationObject(), sortArray: event.sorts, query: query });
  }

  selectTableColumns(event, addNewColumn?: boolean) {
    let columnsToBeExcluded = [
      'Navigation',
      'identificationCodeMnemonic',
      'personaName',
      'personaIdentifier',
      'checked',
      'jiraUrl',
      ...this.columnsToExclude,
    ];
    /* if removing column */
    let duplicate;
    event.forEach((x) => {
      let count = 0;
      event.forEach((y) => {
        if (x.name == y.name) {
          count++;
          if (count > 1) duplicate = x;
        }
      });
    });
    if (duplicate) {
      remove(event, (item: any) => item.name === duplicate.name);
      this.columns.forEach((element) => {
        if (element.name == duplicate.name) {
          element.selected = false;
        }
      });
      this.removeFromSort(duplicate.name);
      this.removeFromQuery(duplicate.name);
    }
    /* removing colum end */

    /* order columns by default order from the backend */

    this.selectedTableColumns = [];
    this.columnsToDisplayInDropdown = this.columns;

    let sortedEventArray = this.columns.map((el) => {
      return event.find((eventEl) => eventEl.name === el.name);
    });
    sortedEventArray = sortedEventArray.filter((el) => el !== undefined);
    sortedEventArray = sortedEventArray.length == 0 ? event : sortedEventArray;

    if (this.section == 'order' || this.section == 'budget') {
      this.selectedTableColumns.push({
        name: 'identifier',
        prop: 'identifier',
        searchValue: '',
        cellTemplate: this.pickCellTemplate('string', 'identifier'),
        headerTemplate: this.translateCell,
        selected: false,
        width: 130,
      });
    }

    /* order columns by default order from the backend end*/
    sortedEventArray.forEach((el) => {
      this.columns.forEach((element) => {
        if (element.name == el.name) {
          element.selected = true;
        }
      });
      if (el.name !== 'Navigation' && !columnsToBeExcluded.find((e) => e === el.name)) {
        this.selectedTableColumns.push({
          name: el.name,
          prop: el.name,
          searchValue: el.searchValue,
          cellTemplate: this.pickCellTemplate(this.schema[el.name], el.name),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      }
    });
    this.selectedTableColumns.push({
      name: 'Navigation',
      prop: 'Navigation',
      cellTemplate: this.checkNavigation(),
      sortable: false,
      selected: false,
      width: 120,
    });
    // remove fitler, custom id and persona name from dropdown

    this.columnsToDisplayInDropdown = this.columnsToDisplayInDropdown.filter(
      (column: any) => !columnsToBeExcluded.find((c) => column.name === c)
    );
    if (addNewColumn && !duplicate) {
      this.refreshData();
    }
    let selectedColumns = [];
    this.columns.forEach((column) => {
      if (this.selectedTableColumns.find((selectedColumn) => selectedColumn.name === column.name)) {
        selectedColumns.push({ name: column.name });
      }
    });
    localStorage.setItem(this.section + '-default-columns', JSON.stringify(selectedColumns));
  }

  selectAllColumns() {
    this.selectTableColumns(this.columns);
  }

  unselectAllColumns() {
    const columnsToKeep = this.columns.filter(
      (col) => col.name == 'identificationCodeMnemonic' || col.name == 'personaName'
    );

    this.selectedTableColumns.forEach((col) => {
      this.selectTableColumns([col, ...columnsToKeep]);
    });
    this.columns.forEach((col) => (col.selected = false));
  }

  async exportCSV() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';

    let result = await this.service({ pageSize: this.page.totalElements }, this.sortArray, query);
    let columns = this.selectedTableColumns;
    this.columnsToExclude.forEach((columnToExclude) => {
      columns = columns.filter((el) => el.name !== columnToExclude);
    });

    let dataToExport = result.data;

    let data = dataToExport.content;

    // we want export only data that is shown in the selected columns
    const dataForExport = data.map((o) =>
      columns.reduce((acc, curr) => {
        if (curr.name !== 'Navigation') {
          let translatedColumnName: any = this.translate.instant('columnName.' + curr.name);
          acc[translatedColumnName] = o[curr.name] ? o[curr.name] : '';
        }
        return acc;
      }, {})
    );

    let prefix = (this.section && this.subsection) ? '_' : '';
    let subsection = this.subsection ? (prefix + this.subsection) : '';
    let section = this.section ? this.section : '';

    this.csvExporter.options.filename = section + subsection + '-' + moment().toISOString();

    this.csvExporter.generateCsv(dataForExport);
  }

  displaySearch() {
    this.showSearch = !this.showSearch;
    let cells: any = document.getElementsByTagName('datatable-header-cell');
    for (let i = 0; i < cells.length; i++) {
      if (this.showSearch) {
        cells[i].classList.add('datatable-header-cell-search');
      } else {
        cells[i].classList.remove('datatable-header-cell-search');
      }
    }
  }

  async search(columnValue, columnName) {
    let searchValue = columnValue;

    // Normalizzazione Valori (Percentage)
    if (this.schema?.[columnName] === 'percentage' && columnValue.length > 0) {
      const cleanValue = columnValue.replace('%', '').replace(',', '.');
      searchValue = (Number.parseFloat(cleanValue) / 100).toFixed(4);
    }

    // Normalizzazione Valori (Currency)
    if (this.schema?.[columnName] === 'currency' && columnValue.length > 0) {
      const parts = columnValue.split(' ')[0].split(',');
      const thousands = Number.parseFloat(parts[0].replace(/\./g, ''));
      const decimals = parts[1] ? Number.parseFloat(parts[1]) : 0;
      searchValue = decimals > 0 ? `${thousands}.${decimals}` : thousands.toString();
    }

    // Aggiornamento UI locale
    this.selectedTableColumns.find(el => el.name === columnName).searchValue = columnValue;

    // Gestione Query String tramite URLSearchParams
    const params = new URLSearchParams(this.queryString);
    
    if (searchValue.trim().length === 0) {
      params.delete(columnName);
    } else {
      params.set(columnName, searchValue);
    }
    
    this.queryString = decodeURIComponent(params.toString());

    // Navigazione e Fetch
    const queryParam = this.queryString ? `&query=${encodeURIComponent(this.queryString)}` : '';
    
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { query: this.queryString },
      queryParamsHandling: 'merge',
    });

    await this.fetchData({ 
      paginationObject: new PaginationObject(), 
      sortArray: this.sortArray, 
      query: queryParam 
    });
  }

  async removeFromQuery(key) {
    if (this.queryString.includes(key)) {
      let queries = this.queryString.split('&');
      let valueIndex;
      queries.forEach((q, i) => {
        if (q.includes(key)) {
          valueIndex = i;
        }
      });

      queries.splice(valueIndex, 1);
      this.queryString = queries.join('&');
      let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { query: this.queryString },
        queryParamsHandling: 'merge',
      });
      await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
    }
  }

  async removeFromSort(key) {
    this.sortArray = this.sortArray.filter((el) => el.prop !== key);
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
  }

  inputType(columnName: string) {
    if (this.schema?.[columnName] == 'percentage') {
      return 'number';
    }
    if (this.schema?.[columnName]) {
      return this.schema[columnName];
    } else {
      return 'text';
    }
  }

  clearSearchValue(columnName: string) {
    this.selectedTableColumns.find((el) => el.name == columnName).searchValue = '';
    this.selectedTableColumns = [...this.selectedTableColumns];
    this.search('', columnName);
  }

  async clearSearch() {
    this.queryString = '';
    this.selectedTableColumns.forEach((e) => {
      e.searchValue = null;
    });
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sort: sortHelper.constructSort(this.sortArray, true).split('sort=')[1], query: this.queryString },
    });
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: '' });
    this.displaySearch();
  }

  async refreshData() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';

    await this.fetchData({ paginationObject: this.paginationObject, sortArray: this.sortArray, query: query });
  }

  addNewColumn(event) {
    this.selectTableColumns(event, true);
  }

  pickCellTemplate(schemaKey: string, columnName: string) {
    switch (columnName) {
      case 'personaName':
      case 'superiorName':
        return this.personNameCell;
      default:
        break;
    }
    if ((this.section === 'order' || this.section === 'budget') && columnName === 'identifier') {
      return this.checkboxCell;
    }

    if ( this.section === 'budget' && columnName === 'completion') {
      return this.percentageCell;
    }
    switch (schemaKey) {
      case 'percentage':
        return this.percentageCell;
      case 'time':
        return this.timeCell;
      case 'date':
        return this.dateCell;
      case 'currency':
        return this.currencyCell;
      case 'text':
      case 'number':
      case 'boolean':
        return this.plainCell;
      case 'dayHourFormat':
        return this.dayHourFormat;
      default:
        if (columnName !== 'identifier')
          console.log('Found ' + columnName + ' which is not in schema. Defaulting to text input.');
        return this.plainCell;
    }
    
  }

  checkNavigation() {
    if (this.section === 'projects') {
      return this.navigationAndJiraIcon;
    } else if (this.section === 'order-details-project') {
      return this.jiraIcon;
    }
    if (this.section === 'customers') {
      return this.navigationIcon;
    } else if (this.section === 'errors') {
      return this.errorDetails;
    } else {
      return this.navigationIcon;
    }
  }

  onRowSelect(e, row) {
    if (this.selectedRows.find((e) => e === row.identifier)) {
      this.selectedRows = this.selectedRows.filter((e) => e !== row.identifier);
      this.tableData.content.find((el) => {
        if (el.identifier === row.identifier) {
          el.checked = false;
        }
      });
    } else {
      this.selectedRows.push(row.identifier);
      this.tableData.content.find((el) => {
        if (el.identifier === row.identifier) {
          el.checked = true;
        }
      });
    }
  }

  selectAllRows(e) {
    this.checkAll = !this.checkAll;
    if (this.checkAll) {
      this.selectedRows = [];
      this.tableData.content.forEach((row) => {
        row.checked = true;
        this.selectedRows.push(row.identifier);
      });
    } else {
      this.selectedRows = [];
      this.tableData.content.forEach((row) => {
        row.checked = false;
      });
    }
  }

  getDetailsRouteLink(row: any) {
    if (this.section == 'user-management') {
      return 'details/' + row.identifier;
    } else if (this.section == 'order') {
      return '/' + this.section + '/' + row.identifier;
    } else if (this.section == 'projects') {
      return '/project/' + row.identifier;
    } else if (this.section == 'options') {
      return 'option/' + row.identifier;
    } else if (this.section == 'customers') {
      return '/customer/' + row.identifier;
    } else if (this.section == 'errors') {
      return '/errors/' + row.orderCode;
    } else if (this.section == 'budget') {
      return '/order/' + row.orderIdentifier + '/budget/' + row.identifier;
    }
  }

  deleteError(err) {
    this.deleteService(err.identifier).then(() => {
      this.refreshData();
      this.toastService.showSuccess("Operation success!");
    });
  }

  eventRefreshtable(obj:any){
    if(obj.save && obj.save === true){
      this.refreshData();
    }
  }
}
